export function StatusBadge({ status }) {
  const map = {
    pending_payment: { cls: "badge-pending", label: "Awaiting payment", testid: "status-pending-payment" },
    in_queue: { cls: "badge-pending", label: "In queue", testid: "status-in-queue" },
    processing: { cls: "badge-processing", label: "Processing", testid: "status-processing" },
    complete: { cls: "badge-complete", label: "Complete", testid: "status-complete" },
    failed: { cls: "badge-failed", label: "Failed", testid: "status-failed" },
    cancelled: { cls: "badge-failed", label: "Cancelled", testid: "status-cancelled" },
  };
  const s = map[status] || { cls: "badge-pending", label: status, testid: "status-unknown" };
  return (
    <span className={s.cls} data-testid={s.testid} role="status">
      <span aria-hidden="true" className="inline-block w-1.5 h-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
}

export default StatusBadge;
